<template>
    <!--头部-->
    <div class="header-box">
        <div class="header-content">
            <div class="header-content-l">
                <img src="../assets/images/logo_blue.png"
                     alt=""
                     class="img_logo"
                />
                <ul>
                    <li>考点志愿省市选择及缴费</li>
                </ul>
            </div>
            <div class="header-content-r">
                <div class="info no-show">姓名：{{$store.state.accountInfo.name}}</div>
                <div class="info no-show">身份证：{{$store.state.accountInfo.sfz}}</div>
                <div class="logout" @click="logout">退出</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {loginOut} from "r/index/login.js";
    import {Toast} from "vant";

    export default {
        name: "Header",
        data() {
            return {}
        },
        methods: {
            logout() {
                let status = this.isMobileDevice();
                this.$confirm('确认退出登录?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    await loginOut()
                    this.$store.commit('loginOut')
                    status ? Toast('退出成功！') : this.$message.success('退出成功！');
                    await this.$router.replace("/login");
                }).catch(() => {
                    status ? Toast('已取消操作！') : this.$message.info('已取消操作！');
                });
            },
            isMobileDevice() {
                const userAgent = navigator.userAgent || navigator.vendor || window.opera;
                // 移动设备关键字列表
                const isAndroid = /android/i.test(userAgent);
                const isiOS = /iphone|ipad|ipod/i.test(userAgent);
                const isMobile = /Mobile/i.test(userAgent);
                return isAndroid || isiOS || isMobile;
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/scss/base.scss";

    .header-box {
        font-family: "Microsoft YaHei";
        font-size: 14px;
        width: 100%;
        height: 82px;
        background-color: #ffffff;
        border-top: 8px solid var(--color);
        box-shadow: 0px 2px 4px #ccc;

        .header-content {
            /*width: 1100px;*/
            max-width: 1140px;
            height: 80px;
            line-height: 80px;
            margin: 0 auto;
            padding: 0 20px;
            display: flex;
            flex-flow: row;
            align-items: center;
            justify-content: space-between;

            .header-content-l,
            .header-content-r {
                display: flex;
                flex-flow: row;
                align-items: center;

                .img_logo {
                    float: left;
                    /*width: 200px;*/
                    height: 54px;

                    &:hover {
                        cursor: pointer;
                    }
                }

                ul {
                    margin: 0 0 0 57px;
                    padding: 0;

                    li {
                        list-style: none;
                        font-size: 16px;
                        color: var(--color);
                        border-bottom: 4px solid var(--color);
                        cursor: pointer;
                    }
                }

                .info {
                    margin-left: 20px;

                    &:nth-last-child(2) {
                        margin-right: 90px;
                    }
                }

                .logout {
                    height: 30px;
                    line-height: 30px;

                    &:hover {
                        cursor: pointer;
                        color: var(--color);
                        font-weight: bold;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1024px) {
        .header-content-r {
            .no-show {
                display: none !important;
            }
        }
    }

    @media screen and (max-width: 600px) {
        .header-content-l {
            .img_logo {
                height: 44px !important;
            }

            ul {
                display: none !important;
            }
        }
    }
</style>
